import {useTranslation} from "react-i18next";
import {usePlafondFields, useVendorsManagerFields} from "./settingsFields";
import {useGetCities, useGetPlafond} from "../../../services/ContentManager";
import Grid from "@mui/material/Grid";
import RenderFields from "./RenderFields";
import {CircularProgress, Box} from "@mui/material";
import NTMSelect from "../../../components/NTMSelect";
import React, {useState} from "react";
import {TextItem} from "../../../components/TextItem";
import {useParams} from "react-router-dom";
import ResponsiveCircularLoading from "../../../components/ResponsiveCircularLoading";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import { PLAFOND_TYPE } from "constants/plafondType";

export default function Plafond({values, setValues, onError}) {
    let {id} = useParams();
    const {t} = useTranslation();
    let fields = usePlafondFields(values, setValues);
    let {status, plafond} = useGetPlafond(id, PLAFOND_TYPE.INITIATIVE.key);
    const {status: touristicStatus, plafond: touristicPlafond} = useGetPlafond(id, PLAFOND_TYPE.TOURISTIC.key);
    let [error, setError] = useState({});

    const onTextChange = (prop) => (value) => {
        let newValues = {...values};
        newValues[prop] = value;
        setValues(newValues);
        checkError(prop, value)
    }

    const checkError = (prop, value) => {
        if (error && error[prop]) {
            delete error[prop]
            if (Object.keys(error).length === 0) onError(false)
        }
        if (prop == "plafond" && value < plafond.spent) {
            onError(true);
            setError({...error, plafond: t('plafondError')})
        }
        if(prop === "touristicPlafond" && !value && values.isTouristicPlafond) {
            onError(true)
            setError({...error, touristicPlafond: 'touristicPlafond required'});
        }
    }


    return <Grid container spacing={4} style={{margin: 0, width: "100%", marginBottom: "0.5rem"}}>

        <RenderFields fields={fields} values={values} error={error} onTextChange={onTextChange}/>
        {
            renderdPlafondInfo({
                status: status,
                plafond: plafond,
                showPlafond: String(values.isPlafond) === "true",
                labels: {
                    plafondAvailable: t('plafondAvailable'),
                    plafondAvailableInfo: t('plafondAvailableInfo'),
                    plafondSpent: t('plafondSpent'),
                    plafondSpentInfo: t('plafondSpentInfo')
                }
            })
        }
        {
            renderdPlafondInfo({
                status: touristicStatus,
                plafond: touristicPlafond,
                showPlafond: String(values.isTouristicPlafond) === "true",
                labels: {
                    plafondAvailable: t('touristicPlafondAvailable'),
                    plafondAvailableInfo: t('touristicPlafondAvailableInfo'),
                    plafondSpent: t('touristicPlafondSpent'),
                    plafondSpentInfo: t('touristicPlafondSpentInfo')
                }
            })
        }


    </Grid>;
}

function renderdPlafondInfo({ status, plafond, showPlafond, labels }) {
    return (
        <>
            {
                showPlafond && (status === 'loading'
                    ? <ResponsiveCircularLoading />
                    :
                    <>
                        <Grid item xs={12} md={6}>
                            <TextItem value={plafond.available}
                                label={
                                    <Box sx={{ whiteSpace: 'noWrap' }}>
                                        {labels.plafondAvailable}
                                        <Tooltip title={labels.plafondAvailableInfo}>
                                            <IconButton sx={{ color: 'info' }}>
                                                <InfoIcon fontSize='small' />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                } />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextItem value={plafond.spent}
                                label={
                                    <Box sx={{ whiteSpace: 'noWrap' }}>
                                        {labels.plafondSpent}
                                        <Tooltip title={labels.plafondSpentInfo}>
                                            <IconButton sx={{ color: 'info' }}>
                                                <InfoIcon fontSize='small' />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                } />
                        </Grid>
                    </>)
            }
        </>
    );
}